(()=>{
let closeTimer;
function openMenu(menu){clearTimeout(closeTimer);for(const other of document.querySelectorAll('.iv-nav details[open]'))if(other!==menu)other.open=false;menu.open=true}
for(const menu of document.querySelectorAll('.iv-nav details')){
  menu.addEventListener('pointerenter',()=>openMenu(menu));
  menu.addEventListener('pointerleave',()=>{closeTimer=setTimeout(()=>menu.open=false,140)});
  menu.querySelector('summary')?.addEventListener('click',event=>{
    // Hoofditem met eigen overzichtspagina: klik navigeert, hover/toetsenbord opent het menu.
    if(event.target.closest('a[href]'))return;
    event.preventDefault();
    if(!menu.open)openMenu(menu);
  });
}
document.addEventListener('toggle',event=>{const menu=event.target;if(!menu.matches?.('.iv-nav details')||!menu.open)return;for(const other of document.querySelectorAll('.iv-nav details[open]'))if(other!==menu)other.open=false},true);
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const menu=document.activeElement?.closest('.iv-nav details[open]');if(menu){menu.open=false;menu.querySelector('summary').focus()}});
document.addEventListener('click',event=>{if(!event.target.closest('.iv-nav'))document.querySelectorAll('.iv-nav details[open]').forEach(menu=>menu.open=false)});
})();
